import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import ECDialog from '../components/ECDialog';
import PlayersPanel from '../player/PlayersPanel';
import { retrieveOnlinePlayers } from './api';

export default function OnlinePlayerListDialog({ visible, onClose }) {

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const loadPlayers = async () => {
        const onlinePlayers = await retrieveOnlinePlayers();
        setData(onlinePlayers);
        setFilteredData(onlinePlayers);
    };

    useEffect(() => {
        loadPlayers();
    }, [visible]);

    useEffect(() => {
        if (search.length === 0) {
            setFilteredData(data);
        } else {
            const filtered = data.filter(p => p.ign.toLowerCase().includes(search.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [search]);

    const handleClick = (player) => {
        onClose();
        navigate(`/player/${player.id}`);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    return (
        <ECDialog
            title='Online Players'
            visible={visible}
            onClose={onClose}
        >
            <TextField label="Search" variant="standard" value={search} fullWidth onChange={handleSearchChange} />
            <PlayersPanel players={filteredData} onSelect={handleClick} />
        </ECDialog>
    );
}
